<template lang="html">
  <section class="cars container">
    <div class="wrapper">
      <div class="cars__list">
        <filters
          @filtersUpdated="handleFiltersUpdate"
          @segmentUpdated="handleSegmentUpdate"
          :highestPrice="highestPrice"
          :segments="JSON.parse(this.segments)"
          :highestMileage="highestMileage"
          :modelsFilter="modelsFilter"
        ></filters>

        <sorts
          :currentSort="currentSort"
          :sortOptions="sortOptions"
          :activeCampaign="activeCampaign"
          :carsCount="filteredCars.length"
          @sortby="onSortby"
          @campaign="onCampaign"
        ></sorts>

        <transition name="fade" mode="out-in">
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
            key="list"
          >
            <used-car
              v-for="car in filteredCars"
              :car="JSON.stringify(car)"
              :key="car.id"
            ></used-car>
            <div v-if="filteredCars.length === 0" class="text-xl">
              Ingenting å vise
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import Filters from '../partials/Filters.vue';
import Sorts from '../partials/Sorts.vue';

import sortCarsOptions from '../data/sortCarsOptions';
import CarHelper from '../helper/CarHelper.js';

import UsedCar from './UsedCar.vue';

export default {
  name: 'UsedCars',
  props: {
    segments: String,
    items: String,
  },
  components: {
    UsedCar,
    sorts: Sorts,
    filters: Filters,
  },
  data: function () {
    return {
      cars: [],
      currentSort: sortCarsOptions[0],
      sortOptions: sortCarsOptions,
      activeFilters: null,
      activeSegment: null,
      activeCampaign: false,
      highestPrice: 0,
      highestMileage: 0,
      modelsFilter: {
        name: 'brand',
        type: 'select',
        options: [],
      },
    };
  },
  mounted() {
    this.cars = JSON.parse(this.items);

    this.highestPrice = Math.max.apply(
      Math,
      this.cars.map(({ price }) => price)
    );

    this.highestMileage = Math.max.apply(
      Math,
      this.cars.map(({ mileage }) => mileage)
    );

    this.getModels();
  },

  methods: {
    getModels() {
      let modelsHelper = [];
      const brandsToNormalize = ['volvo'];
      for (const car of this.cars) {
        let brand = car.brand;
        if (brandsToNormalize.includes(brand.toLowerCase())) {
          brand = brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase();
        }

        if (!modelsHelper.includes(brand)) {
          modelsHelper.push(brand);
          modelsHelper = [...new Set(modelsHelper)];
          // make sure car brands are

          this.modelsFilter.options.push({
            name: `brands.${brand}`,
            value: `${brand}`,
          });
        }
      }

      this.modelsFilter.options = this.modelsFilter.options.sort((a, b) =>
        a.value > b.value ? 1 : -1
      );

      const jsonObject = this.modelsFilter.options.map(JSON.stringify);
      const uniqueSet = new Set(jsonObject);
      this.modelsFilter.options = Array.from(uniqueSet).map(JSON.parse);
    },
    onSortby(v) {
      this.currentSort = v;
    },
    onCampaign(v) {
      this.activeCampaign = v;
    },
    filterCars() {
      let carsToReturn = this.cars;
      if (this.activeSegment) {
        carsToReturn = carsToReturn.filter(
          (car) => car.segment === this.activeSegment
        );
      }

      if (this.activeFilters) {
        this.activeFilters.forEach((item) => {
          carsToReturn = CarHelper.applyFilter(item, carsToReturn);
        });
      }

      if (this.activeCampaign) {
        carsToReturn = carsToReturn.filter((car) => car.campaign);
      }

      return CarHelper.sortCars(this.currentSort, carsToReturn);
    },

    handleFiltersUpdate(payload) {
      this.activeFilters = payload;
    },
    handleSegmentUpdate(payload) {
      this.activeSegment = payload == 'all' ? null : payload;
    },
    resetSort() {
      this.currentSort = sortCarsOptions[0];
    },
  },

  computed: {
    filteredCars() {
      return this.filterCars();
    },
  },
};
</script>
